import { useMemo } from 'react'

import { useTranslation } from 'react-i18next'

import {
  Typography,
  TypographyVariant,
  TypographyWeight,
} from 'src/components/atoms'
import { Column, Data } from 'src/components/organisms/table/types'

import type { IPortfolioNewsArticleEntity } from '../types'

const asArticleRow = (row: Data): IPortfolioNewsArticleEntity =>
  row as unknown as IPortfolioNewsArticleEntity

const textCell =
  (property: keyof IPortfolioNewsArticleEntity) =>
  (row: Data): JSX.Element => {
    const item = asArticleRow(row)
    return (
      <td className="pr-6">
        <Typography
          variant={TypographyVariant.bodyXs}
          className="text-content-secondary"
        >
          {String(item[property])}
        </Typography>
      </td>
    )
  }

export const usePortfolioNewsTableColumns = (): Column[] => {
  const { t } = useTranslation()

  return useMemo(
    (): Column[] => [
      {
        property: 'articleName',
        header: t('portfolioNews.table.articleName'),
        width: '600px',
        renderRowCell: row => {
          const item = asArticleRow(row)
          return (
            <td className="pr-6">
              <Typography
                variant={TypographyVariant.title2Xs}
                weight={TypographyWeight.light}
                className="text-content-primary"
              >
                {item.articleName}
              </Typography>
            </td>
          )
        },
      },
      {
        property: 'company',
        header: t('portfolioNews.table.company'),
        width: '220px',
        renderRowCell: textCell('company'),
      },
      {
        property: 'source',
        header: t('portfolioNews.table.source'),
        width: '220px',
        renderRowCell: textCell('source'),
      },
      {
        property: 'publishedDisplay',
        header: t('portfolioNews.table.published'),
        width: '136px',
        renderRowCell: textCell('publishedDisplay'),
      },
    ],
    [t],
  )
}
